import { autoinject } from "aurelia-framework";
import {AddSubtaskDialog} from "../add-subtask-dialog/add-subtask-dialog";
import {NotificationClientService} from "../../../../../../services/basics/notification-client.service";
import {VettingService} from "../../../../../../services/vetting/vetting.service";
import {CacheClientService} from "@rightship-tech/common-ui/services/basic/client-caching.service";
import {EntityValidationsService} from "../../../../../../client-validation-system/validations-service";
import {SubtasksService} from "../../../../../../services/subtasks/subtasks.service";
import { EntityTypeConfigurationHelper } from "../../../../../../models/basics/basics.models";
import {UserClaimsService} from "../../../../../../services/authentication/user-claims.service";
import { Claims } from "../../../../../../constants/authentication/claims";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";


@autoinject
export class ContactVetRequestorDialog extends AddSubtaskDialog {

    public showChangestatustoAwaitingCheckbox: boolean;

    constructor(public dialogClientService: DialogClientService, notificationClientService: NotificationClientService, vetClientService: VettingService,
                cacheClient: CacheClientService, entityValidationsService: EntityValidationsService,
                subtaskService: SubtasksService, entityTypeConfigurationHelper: EntityTypeConfigurationHelper, userClaimsService: UserClaimsService) {
        super(dialogClientService, notificationClientService, vetClientService,
            cacheClient, entityValidationsService,
            subtaskService, entityTypeConfigurationHelper, userClaimsService);

            this.showChangestatustoAwaitingCheckbox = 
                userClaimsService.hasPermission(Claims.ShowChangestatustoAwaitingcheckbox);
    }

    close(){
        this.dialogClientService.hide();
    }

    getIsExternal(){
        return true;
    }
    
    skipInvitation() {
        return true;
    }
}